import type { UserRole } from '../stores/authStore'

interface ActiveLocation {
  pathname: string
  search: string
}

/** True on a school hub's Classes tab (`/schools/:id?tab=classes`). */
export const isSchoolClassesTab = ({ pathname, search }: ActiveLocation) =>
  /^\/schools\/[^/]+\/?$/.test(pathname) &&
  new URLSearchParams(search.startsWith('?') ? search.slice(1) : search).get('tab') === 'classes'

/**
 * Where the sidebar's "Classes" entry goes. A single-school admin lands straight on that
 * school's Classes tab (the hub opens the current year); everyone else gets the chooser.
 */
export const resolveClassesNavTarget = (role: UserRole | null, schoolIds: string[]): string =>
  role === 'SCHOOL_ADMIN' && schoolIds.length === 1
    ? `/schools/${schoolIds[0]}?tab=classes`
    : '/classes'
